import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'account.orderHistory.title',
    defaultMessage: 'Order History',
  },
  subTitle: {
    id: 'account.orderHistory.subTitle',
    defaultMessage: 'Your purchases',
  },
  empty: {
    id: 'account.orderHistory.empty',
    defaultMessage: 'You have not placed any orders.',
  },
  loadMore: {
    id: 'account.orderHistory.loadMore',
    defaultMessage: 'Load More Orders',
  },
});
